import React, { Component } from 'react';
import './ActivityCard.css';
import Icon from '../../../components/icon/Icon';
import Label from '../../../components/label/Label';
import Volume from '../../../components/volume/Volume';
import utils from '../../../utils/utils';
import { getDisplayUnit, getDrugName } from '../../../utils/gramUtils';

let pastTense = {
	administer: 'Administered',
	take_ownership: 'Created',
	waste: 'Wasted',
	un_administer: 'Un-Administered',
	box_check: 'Inventory Check',
	reseal: 'Reseal',
	box_transfer: 'Transferred',
	drug_transfer: 'Transferred'
};

let iconName = {
	administer: 'check-green',
	take_ownership: 'check-green',
	waste: 'trash-red',
	un_administer: 'discrepancy-orange',
	box_check: 'calendar-blue',
	reseal: 'calendar-blue',
	box_transfer: 'arrow-forward-blue',
	drug_transfer: 'arrow-forward-blue'
};

export default class ActivityCard extends Component {
	get parentElement() {
		return this.element.parentElement;
	}

	componentDidMount = () => {
		if (this.props.animate) {
			setTimeout(() => {
				this.element.classList.add('open');
				this.element.parentElement.parentElement.classList.add('animating');
				this.element.parentElement.parentElement.style.left =
					parseInt(this.element.parentElement.parentElement.style.left.replace('px', '')) - 335 / 2 + 'px';
				this.element.parentElement.parentElement.style.top =
					parseInt(this.element.parentElement.parentElement.style.top.replace('px', '')) - 145 / 2 + 'px';
			}, 10);
		}
	};

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.closing) {
			this.element.classList.remove('open');
			this.element.parentElement.parentElement.style.left =
				parseInt(this.element.parentElement.parentElement.style.left.replace('px', '')) + 335 / 2 + 'px';
			this.element.parentElement.parentElement.style.top =
				parseInt(this.element.parentElement.parentElement.style.top.replace('px', '')) + 145 / 2 + 'px';
			setTimeout(() => {
				this.element.parentElement.parentElement.classList.remove('animating');
			}, 500);
		}
	}

	contains = (arg) => {
		return this.element.contains(arg);
	};

	classes = () => {
		return (this.props.animate ? 'animate' : '') + ' g-activity-card';
	};

	render() {
		let action = this.props.stock_move_type__display_name;
		let recordType = this.props.record_type;

		return (
			<div
				style={this.props.style}
				ref={(ref) => (this.element = ref)}
				className={this.classes()}
				onClick={this.props.onClick}
			>
				<div className="top">
					<Label className="first avatar">{initials(this.props.user_name)}</Label>
					<div className="second">
						<Label bold black className="name-row">
							{this.props.user_name}
						</Label>
						<Label medium-small className="unit-row">
							Unit {this.props.unit__name}
						</Label>
					</div>
					<Icon className="last" size="x-small" name={iconName[action || recordType]} />
				</div>
				<div className="middle">{getMessage(action, recordType, this.props)}</div>
				<Label medium-small className="bottom">
					{utils.display_actual_datetime(this.props.created_on)}
				</Label>
			</div>
		);
	}
}

let getMessage = (action, recordType, obj) => {
	let toReturn = null;
	if (recordType === 'stock_move_record') {
		toReturn = (
			<>
				<Label
					green={action === 'administer' || action === 'take_ownership'}
					orange={action === 'un_administer'}
					red={action === 'waste'}
					className="action"
				>
					{pastTense[action || recordType]}
				</Label>
				{Volume.inPreferredUnit(Math.abs(obj.quantity), obj.type)}
				{getDisplayUnit(obj.type)} of {getDrugName(obj.type)} ({utils.upperCase(obj.barcode_id)}) from{' '}
				<Label className="inner-bold-label" black-light bold>
					{obj.drug_box__name}
				</Label>
			</>
		);
	} else if (recordType === 'drug_transfer') {
		toReturn = (
			<>
				<Label blue className="action">
					{pastTense[action || recordType]}
				</Label>
				<Label className="inner-bold-label" black-light bold>
					{' '}
					{getDrugName(obj.type)} ({utils.upperCase(obj.barcode_id)}){' '}
				</Label>{' '}
				to{' '}
				<Label className="inner-bold-label" black-light bold>
					{obj.drug_box__name}
				</Label>
				. Verified by{' '}
				<Label className="inner-bold-label" black-light bold>
					{obj.verified_by_name || obj.guest_verify_name}
				</Label>
			</>
		);
	} else if (recordType === 'box_transfer') {
		toReturn = (
			<>
				<Label blue className="action">
					{pastTense[action || recordType]}
				</Label>
				<Label className="inner-bold-label" black-light bold>
					{obj.drug_box__name}{' '}
				</Label>{' '}
				to{' '}
				<Label className="inner-bold-label" black-light bold>
					{obj.unit__name}
				</Label>
				. Verified by{' '}
				<Label className="inner-bold-label" black-light bold>
					{obj.verified_by_name || obj.guest_verify_name}
				</Label>
			</>
		);
	} else {
		toReturn = (
			<>
				<Label blue className="action">
					{pastTense[action || recordType]}
				</Label>
				{obj.drug_box__name} ({utils.upperCase(obj.barcode_id)}) with {obj.drug_count} vials, verified by{' '}
				<Label className="inner-bold-label" black-light bold>
					{obj.verified_by_name || obj.guest_verify_name}
				</Label>
			</>
		);
	}
	return <Label black-light>{toReturn}</Label>;
};

let initials = (name) => {
	if (!name) return '';
	let nameArray = name.split(' ');
	if (!nameArray) return '';
	if (!nameArray[0]) return '';
	if (!nameArray[1]) return nameArray[0][0];
	return nameArray[0][0] + nameArray[1][0];
};



// WEBPACK FOOTER //
// ./src/pages/activityMapPage/activityCard/ActivityCard.jsx